module.exports = __webpack_public_path__ + "static/img/38_pro.5c97d8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/38_pro.jpg
// module id = Lz0K
// module chunks = 0